import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../../Catalyst/button";
import { useNavigate } from "react-router";
import { fetchOrganizationDetailsAsync } from "../../../store/thunks/OrganizationThunk";
import OrganizationTable from "../OrganizationTable/OrganizationTable";
import { AppDispatch, RootState } from "../../../store/store";
import useOrgId from "../../../hooks/useOrgId";
import BackIcon from "../../../assets/BackIcon";


export const OrgView = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const orgDetails = useSelector((state: RootState) => state.OrganizationListStore?.selectedOrgDetails);
  const orgId = useOrgId();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (orgId) {
      dispatch(fetchOrganizationDetailsAsync(orgId));
    }
  }, [orgId, dispatch]);

  const handleViewOrganization = async (orgId: number) => {
    setLoading(true);
    try {
      const response = await dispatch(fetchOrganizationDetailsAsync(orgId));
      if (response?.payload) {
        navigate(`/org-view/${orgId}`);
      } else {
        // eslint-disable-next-line no-console
        console.error("Failed to fetch organization details.");
      }
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error("Error fetching organization details:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateEntity = () => {
    const createPath = orgId ? `/create-org/${orgId}` : '/create-org';
    navigate(createPath, { state: { selectedOrgDetails: orgId } });
  };

  const handleBackToParent = () => {
    const parentOrgId = orgDetails?.parentOrgId;
    if (parentOrgId) {
      navigate(`/org-view/${parentOrgId}`);
    } else {
      // If no parent, go to org-home
      navigate('/org-view');
    }
  };

  return (
    <>
      {loading && (
        <div className="fixed inset-0 flex items-center justify-center bg-white bg-opacity-60 z-50">
          <div className="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4 animate-spin border-t-blue-500"></div>
        </div>
      )}
      <div className="ml-5  pr-32" >
        <div className="flex justify-between items-center mr-10">
          <div className="flex items-center mb-6 mt-10">
            {/* Show back button if there's a parent organization or if we're not at root */}
            {(orgDetails?.parentOrgId || orgId) && (
              <Button
                plain
                onClick={handleBackToParent}
                className="mr-3 flex items-center justify-center w-10 h-10 rounded-md hover:bg-gray-100 transition-colors"
                title={orgDetails?.parentOrgId ? "Back to parent organization" : "Back to home"}
              >
                <BackIcon />
              </Button>
            )}
            <div className="text-xl font-semibold">
              {(orgDetails?.parentOrgId || orgId) ? orgDetails?.name : 'Organizations'}
            </div>
          </div>
          <Button color="white"
            onClick={handleCreateEntity}
            className="mt-4 text-sm cursor-pointer h-10 flex justify-end"
          >
            Create Organization
          </Button>
        </div>
        <OrganizationTable
            selectedOrgId={orgId}
            handleViewOrganization={handleViewOrganization}
          />
       
      </div>
    </>
  );
};
